import React, {FC, ReactElement, useMemo} from 'react';
import {ColumnChartCard} from "../../../components/ColumnChartCard";
import {useQuerySearchParams} from "../../../config/queryClient";
import {ActivityAttributeMeta, ActivityAttributeReport} from "../../../types";
import {QueryFilter} from "../../../components/DataTable/Filters/types";
import { ColumnConfig } from '@ant-design/charts';
import { useOrdering, OrderingButton } from './Ordering';

interface Props {
    attributeMeta?: ActivityAttributeMeta
}

const chartProps: Omit<ColumnConfig, 'data'> = {
    xField: 'value',
    yField: 'avg_score',
    seriesField: 'value',
    yAxis: {
        min: 0,
        max: 100,
        label: {
            formatter: (text: any) => `${text}%`
        },
    },
}

export const AttributePerformanceColumnChartCard: FC<Props> = ({attributeMeta}): ReactElement => {
    const {data = [], isLoading} = useQuerySearchParams<ActivityAttributeReport[]>(
        `/reports/activity-attributes/`,
        [QueryFilter.COHORTS, QueryFilter.COURSES],
        {defaultFilters: {meta: attributeMeta?.id || ''}}
    );

    const { order, setChartOrder } = useOrdering('desc');

    const chartData = useMemo(() =>
        data.map(attribute => ({...attribute, avg_score: attribute.avg_score ?? 0}))
            .sort((a, b) => order === 'desc' ? b.avg_score - a.avg_score : order === 'asc' ? a.avg_score - b.avg_score : 0), [data, order]);

    return (
        <ColumnChartCard
            title={`Avg. ${attributeMeta?.name || ''} Performance`}
            isLoading={isLoading}
            data={chartData}
            extra={<OrderingButton order={order} setChartOrder={setChartOrder} />}
            {...chartProps}
        />
    );
};